import * as React from 'react';
import { Box, Grid, TextField, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { fCurrency } from '../../../../../../../utils/formatNumber';
import { useEffect, useState } from 'react';
import { get } from '../../../../../../../inteceptor';
import LoyaltyIcon from '@mui/icons-material/Loyalty';

export default function LoyaltyCollection({ getPaymentTypeTotalAmount, handlePriceChange, setIsModelOpen, data, getTotalPaidAmount, selectedPaymentType }) {
  const [loyaltyBalance, setLoyaltyBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  const customerId = data?.customerInfo?.id;
  const amountLeftToPay = Math.max(0, (data?.paymentRecords?.totalPayable || 0) - (getTotalPaidAmount || 0));
  const currentLoyaltyAmount = getPaymentTypeTotalAmount()?.amount || 0;
  const maxRedeemable = Math.min(loyaltyBalance, amountLeftToPay + currentLoyaltyAmount);

  useEffect(() => {
    if (customerId) {
      setLoading(true);
      get(`getCustomerLoyaltyBalance?customerId=${customerId}`)
        .then((response) => {
          if (response?.status) {
            setLoyaltyBalance(response?.loyaltyBalance || 0);
          }
        })
        .catch(() => {
          setLoyaltyBalance(0);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      setLoyaltyBalance(0);
    }
  }, [customerId]);

  const handleAmountChange = (value) => {
    const numValue = Number(value);
    if (numValue > maxRedeemable) {
      handlePriceChange(true, maxRedeemable);
    } else {
      handlePriceChange(true, numValue >= 0 ? numValue : 0);
    }
  };

  if (!customerId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity='warning'>Please select a customer before using Loyalty Points payment.</Alert>
        <LoadingButton onClick={() => setIsModelOpen(false)} variant='contained' size='large' color='info'
          style={{ width: '100%', marginTop: '50px', minHeight: '70px', fontWeight: 800, fontSize: '1.6em' }}>
          Close
        </LoadingButton>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <h2>Loading loyalty balance...</h2>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ p: 2 }}>
        <h2>Redeem Loyalty Points</h2>
      </Box>

      <Grid container justifyContent='left' p={3}>
        <Grid item md={3}>
          <h6>Payable Amount</h6>
          <h1>{fCurrency(data?.paymentRecords?.totalPayable)}</h1>
        </Grid>
        <Grid item md={3}>
          <h6>Total Entered Amount</h6>
          <h1>{fCurrency(getTotalPaidAmount)}</h1>
        </Grid>
        <Grid item md={3}>
          <h6>Amount Left to Pay</h6>
          <h1>{fCurrency(amountLeftToPay)}</h1>
        </Grid>
        <Grid item md={3}>
          <h6 style={{ display: 'flex', alignItems: 'center' }}>
            <LoyaltyIcon style={{ marginRight: '4px', color: '#f50057' }} /> Available Balance
          </h6>
          <h1 style={{ color: loyaltyBalance > 0 ? '#2e7d32' : '#d32f2f' }}>{fCurrency(loyaltyBalance)}</h1>
        </Grid>
      </Grid>

      {loyaltyBalance <= 0 ? (
        <Box sx={{ p: 3 }}>
          <Alert severity='info'>This customer has no loyalty points available for redemption.</Alert>
        </Box>
      ) : (
        <Grid container justifyContent='left' p={3}>
          <Grid item md={4}>
            <TextField
              type='number'
              variant='outlined'
              label='Redeem Amount'
              sx={{ width: '90%', marginTop: '20px' }}
              placeholder='Enter amount to redeem'
              value={currentLoyaltyAmount || ''}
              onChange={(event) => {
                handleAmountChange(event?.target?.value);
              }}
              inputProps={{ min: 0, max: maxRedeemable }}
              helperText={`Max redeemable: ${fCurrency(maxRedeemable)}`}
            />
          </Grid>

          <Grid item md={4}>
            <LoadingButton
              onClick={() => {
                const useAmount = Math.min(loyaltyBalance, amountLeftToPay + currentLoyaltyAmount);
                handlePriceChange(true, useAmount);
              }}
              variant='outlined'
              size='large'
              color='success'
              style={{ width: '90%', marginTop: '20px' }}
            >
              Use Full Balance ({fCurrency(maxRedeemable)})
            </LoadingButton>
          </Grid>

          <Grid item md={4}>
            <LoadingButton
              onClick={() => {
                const payRemaining = Math.min(amountLeftToPay + currentLoyaltyAmount, loyaltyBalance);
                handlePriceChange(true, payRemaining);
              }}
              variant='outlined'
              size='large'
              style={{ width: '90%', marginTop: '20px' }}
              disabled={loyaltyBalance <= 0}
            >
              Pay Remaining ({fCurrency(Math.min(amountLeftToPay + currentLoyaltyAmount, loyaltyBalance))})
            </LoadingButton>
          </Grid>
        </Grid>
      )}

      <Grid container p={3}>
        <LoadingButton
          onClick={() => setIsModelOpen(false)}
          variant='contained'
          size='large'
          color='info'
          style={{ width: '100%', marginTop: '50px', marginLeft: '2.5%', minHeight: '70px', fontWeight: 800, fontSize: '1.6em' }}
        >
          Confirm & Close
        </LoadingButton>
      </Grid>
    </>
  );
}
